const carouselItems = [
  {
    title: '暑期档 · 动作巨制连映',
    desc: '这个夏天最燃的动作大片合集，从《极限营救》到《暗夜追踪》，每一帧都是蓝光画质，每一秒都让你肾上腺素飙升。麻花影院为你准备了完整的暑期观影清单。',
    tag: '热门策划',
    imageSrc: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20collage%20with%20explosive%20urban%20scenes%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20orange%20tones%2C%20professional%20film%20cinematography%20style%2C%20intense%20atmosphere%2C%20movie%20themed%20banner%20design&width=1200&height=600&seq=mahua-carousel-01&orientation=landscape',
    imageAlt: '暑期档动作巨制连映专题',
  },
  {
    title: '经典修复 · 华语电影黄金年代',
    desc: '500+部经典华语影片以4K修复技术重焕新生。从邵氏武侠到香港新浪潮，从第五代导演到独立佳作，那些曾经感动我们的银幕记忆，如今以超清画质再次呈现。',
    tag: '经典回顾',
    imageSrc: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20retrospective%20banner%20with%20vintage%20film%20aesthetic%2C%20warm%20nostalgic%20golden%20tones%2C%20traditional%20Chinese%20visual%20elements%2C%20old%20film%20texture%2C%20elegant%20cinematic%20design%2C%20classic%20movie%20atmosphere&width=1200&height=600&seq=mahua-carousel-02&orientation=landscape',
    imageAlt: '华语电影黄金年代经典修复专题',
  },
  {
    title: '纪录之眼 · 真实世界的震撼',
    desc: '从北极冰川到非洲草原，从深海秘境到太空探索。麻花影院纪录片精选频道以4K超清画质，带你领略地球与宇宙的壮美奇观，足不出户看遍世界的每一个角落。',
    tag: '纪录片精选',
    imageSrc: 'https://readdy.ai/api/search-image?query=Documentary%20film%20banner%20with%20stunning%20nature%20landscapes%2C%20mountains%20oceans%20and%20wildlife%2C%20cinematic%20wide%20shots%2C%20warm%20natural%20lighting%2C%20professional%20nature%20photography%20style%2C%20epic%20scale%20documentary%20design&width=1200&height=600&seq=mahua-carousel-03&orientation=landscape',
    imageAlt: '纪录之眼真实世界的震撼专题',
  },
  {
    title: '科幻宇宙 · 想象力的边界',
    desc: '《星际远征》领衔的科幻巨制阵容，以4K HDR超清画质呈现浩瀚宇宙。从星际旅行到人工智能，从平行世界到时间穿越，每一部都是视听盛宴，让你的想象力突破天际。',
    tag: '科幻盛宴',
    imageSrc: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20banner%20with%20futuristic%20space%20theme%2C%20colorful%20nebula%20and%20galaxy%20background%2C%20spaceship%20and%20technology%20elements%2C%20dramatic%20cinematic%20lighting%2C%20professional%20sci-fi%20film%20design%2C%20epic%20cosmic%20scale&width=1200&height=600&seq=mahua-carousel-04&orientation=landscape',
    imageAlt: '科幻宇宙想象力边界专题',
  },
  {
    title: '惊悚悬疑 · 烧脑午夜剧场',
    desc: '精选全球高分悬疑惊悚影片，从心理恐怖到犯罪推理，从超自然现象到密室逃脱。麻花影院以蓝光画质还原每一个细思极恐的细节，挑战你的推理极限和胆量。',
    tag: '悬疑专场',
    imageSrc: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20banner%20with%20dark%20moody%20atmosphere%2C%20film%20noir%20style%20lighting%2C%20shadowy%20urban%20scenes%2C%20suspenseful%20cinematic%20design%2C%20professional%20thriller%20film%20aesthetic%2C%20dramatic%20contrast&width=1200&height=600&seq=mahua-carousel-05&orientation=landscape',
    imageAlt: '惊悚悬疑烧脑午夜剧场专题',
  },
  {
    title: '动画嘉年华 · 全家的欢乐时光',
    desc: '从皮克斯式的暖心故事到日本动画大师的视觉奇观，从国产动画新势力到欧洲独立动画。麻花影院动画专区以4K超清画质，为大小朋友打造最丰富的动画观影体验。',
    tag: '动画精选',
    imageSrc: 'https://readdy.ai/api/search-image?query=Animation%20movie%20banner%20with%20colorful%20magical%20fantasy%20world%2C%20vibrant%20characters%20in%20whimsical%20setting%2C%20warm%20cheerful%20colors%2C%20professional%20animation%20film%20design%2C%20family%20friendly%20cinematic%20atmosphere%2C%20creative%20visual&width=1200&height=600&seq=mahua-carousel-06&orientation=landscape',
    imageAlt: '动画嘉年华全家欢乐时光专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-accent-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-sparkling-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">焦点策划</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              热门专题
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              深度策划的影视专题，带你发现不一样的观影视角
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {carouselItems.map((item) => (
              <div key={item.title} className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200/70 transition-all duration-300 cursor-pointer">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.imageSrc}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="bg-black/55 backdrop-blur-sm text-white text-[10px] px-2.5 py-0.5 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-foreground-900 font-semibold text-base mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}